import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Permission, PermissionsService } from '../services/permissions.service';

/**
 * Render the contents of the element only if the signed-in user holds the permission
 * (UHD-1716). Mirrors appIfFeatureEnabled, but per user instead of per account.
 *
 *   <button *appIfPermission="Permission.DeviceRemoteDebug">Debug</button>
 */
@Directive({
    selector: '[appIfPermission]',
    standalone: false
})
export class IfPermissionDirective {
  private permission: Permission | string;

  @Input() set appIfPermission(permission: Permission | string) {
    this.permission = permission;
    this.updateView();
  }

  public constructor(
    private readonly permissionsService: PermissionsService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly templateRef: TemplateRef<unknown>
  ) { }

  private updateView(): void {
    this.viewContainerRef.clear();
    if (this.permission && this.permissionsService.has(this.permission)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
